import { ChangeDetectionStrategy, Component, input, computed } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  lucideCircleAlert,
  lucideTriangleAlert,
  lucideInfo,
} from '@ng-icons/lucide';
import { getAnalysisErrorMessage, getErrorCodeMetadata, isErrorRetryable } from '@shared/models/error-code.model';

@Component({
  selector: 'app-analysis-error-detail',
  standalone: true,
  imports: [NgIcon],
  viewProviders: [
    provideIcons({ lucideCircleAlert, lucideTriangleAlert, lucideInfo }),
  ],
  templateUrl: './analysis-error-detail.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnalysisErrorDetailComponent {
  readonly errorCode = input<string | null | undefined>(undefined);
  readonly errorMessage = input<string | null | undefined>(undefined);
  readonly errorDetail = input<string | null | undefined>(undefined);
  readonly compact = input<boolean>(false);

  protected readonly displayDetail = computed(() =>
    getAnalysisErrorMessage(this.errorCode(), this.errorMessage(), this.errorDetail()));

  protected readonly meta = computed(() => {
    const code = this.errorCode();
    return code ? getErrorCodeMetadata(code) : null;
  });

  protected readonly retryable = computed(() => {
    const code = this.errorCode();
    return code ? isErrorRetryable(code) : false;
  });

  protected readonly iconName = computed(() => {
    const icon = this.meta()?.icon ?? 'error';
    if (icon === 'warning') return 'lucideTriangleAlert';
    if (icon === 'info') return 'lucideInfo';
    return 'lucideCircleAlert';
  });
}
